<template>
    <div class="arrow" id="arrow" @click="handleClick">
        <svg viewBox="0 0 138 45" fill="none" id="arrow-first">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M137.457 5.22266L68.6907 44.9247L66.1907 40.5945L134.957 0.892529L137.457 5.22266Z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M68.7659 44.7021L0 5.00005L2.5 0.669922L71.2659 40.3719L68.7659 44.7021Z"
            />
        </svg>
        <svg viewBox="0 0 138 45" fill="none" id="arrow-second">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M137.457 5.22266L68.6907 44.9247L66.1907 40.5945L134.957 0.892529L137.457 5.22266Z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M68.7659 44.7021L0 5.00005L2.5 0.669922L71.2659 40.3719L68.7659 44.7021Z"
            />
        </svg>
        <svg viewBox="0 0 138 45" fill="none" id="arrow-third">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M137.457 5.22266L68.6907 44.9247L66.1907 40.5945L134.957 0.892529L137.457 5.22266Z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M68.7659 44.7021L0 5.00005L2.5 0.669922L71.2659 40.3719L68.7659 44.7021Z"
            />
        </svg>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'Arrows',
    setup() {
        const handleClick = () => {
            const el = document.querySelector('.landing__hero')
            const top = el?.scrollHeight

            window.scrollTo({
                top: top,
                left: 0,
                behavior: 'smooth',
            })
        }

        return {
            handleClick,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins';

.arrow {
    position: absolute;
    height: 100vh;
    display: flex;
    flex-direction: column;
    left: 50%;
    top: 93vh;
    transform: translateX(-50%);
    z-index: 90;
    cursor: pointer;

    @include mQ(900px) {
        top: 85vh;
    }

    & svg {
        margin-top: -0.3rem;
        width: 50px;
        height: 17px;

        @include mQ(900px) {
            width: 40px;
            height: 13px;
        }
    }

    & #arrow-first {
        @include slideDownInfinite(350ms);

        & path {
            fill: $accent-color;
        }
    }

    & #arrow-second {
        @include slideDownInfinite(250ms);

        & path {
            fill: lighten($accent-color, 10%);
        }
    }

    & #arrow-third {
        @include slideDownInfinite(150ms);

        & path {
            fill: lighten($accent-color, 20%);
        }
    }

    @include mQ(900px) {
        bottom: 5vh;
    }
}
</style>
